import { Control, FieldPath, FieldValues } from 'react-hook-form'

import { Switch } from '../switch'

import { FormControl, FormField, FormItem, FormLabel } from '.'

interface FormCheckboxProps<T extends FieldValues> {
    control: Control<T>
    name: FieldPath<T>
    label: React.ReactNode
    className?: string
}

export default function FormSwitch<T extends FieldValues>({ control, name, label, className }: FormCheckboxProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => {
                const { onChange, value, ...rest } = field
                return (
                    <FormItem className={className}>
                        <div className={`just flex flex-row items-center space-x-3`}>
                            <FormControl>
                                <Switch
                                    {...rest}
                                    checked={value !== undefined ? !!value : false}
                                    onCheckedChange={onChange}
                                />
                            </FormControl>

                            <FormLabel className="mb-0">{label}</FormLabel>
                        </div>
                    </FormItem>
                )
            }}
        />
    )
}
